import { configureStore } from "@reduxjs/toolkit";
import drawerReducer from "./drawer";
import userReducer from "./userInfo";

export default configureStore({
  reducer: {
    drawer: drawerReducer,
    userInfo: userReducer,
  },
});